import { LAST_UPDATED, SITE_NAME, TOS_SECTIONS } from "@/lib/legal";

export default function Terms() {
    return (
        <div className="max-w-3xl mx-auto px-6 md:px-8 py-12" data-testid="terms-page">
            <div className="text-[#ff4500] text-xs uppercase tracking-[0.3em] mb-2">Legal</div>
            <h1 className="font-display text-5xl tracking-wide">Terms of Service</h1>
            <div className="text-xs uppercase tracking-[0.2em] text-[#a0a0a0] mt-3">Last updated: {LAST_UPDATED}</div>
            <div className="h-px bg-[#2a2a2a] my-8" />

            <div className="border border-[#ff4500]/40 bg-[#ff4500]/10 px-5 py-4 mb-8">
                <div className="text-[10px] uppercase tracking-[0.2em] text-[#ff4500] mb-1">Not affiliated with any listed organization</div>
                <p className="text-sm text-white leading-relaxed">
                    <strong>{SITE_NAME}</strong> is an independent directory and is not affiliated with, endorsed by,
                    or sponsored by any of the organizations, leagues, sanctioning bodies, teams, trainers, events,
                    or brands listed or referenced on this site.
                </p>
            </div>

            <div className="space-y-8 text-[#cfcfcf] leading-relaxed">
                {TOS_SECTIONS.map((sec) => (
                    <section key={sec.heading}>
                        <h2 className="font-display text-2xl tracking-wide text-white mb-3">{sec.heading}</h2>
                        {sec.paragraphs.map((p, i) => (
                            <p key={i} className="mb-3 text-sm">{p}</p>
                        ))}
                    </section>
                ))}
            </div>
        </div>
    );
}
